import { call, delay, put } from "redux-saga/effects";

import {
  fetchOfflineProvisioningStatus,
  type OfflineProvisioningStatus,
} from "@utils/api-communication/OfflineProvisioningCli";
import { isOfflineFrontendMode } from "@utils/deviceSetupNavigation";
import { NOT_READ_ONLY, setLicenceStatus, type LicenceState } from "./licenceSlice";

export const LICENCE_POLL_INTERVAL_MS = 60 * 1000;

export const LICENCE_READ_ONLY_TITLE_KEY = "LicenceReadOnly.title";
export const LICENCE_READ_ONLY_MESSAGE_KEY = "LicenceReadOnly.message";
export const LICENCE_EXPIRED_MESSAGE_KEY = "LicenceReadOnly.messageExpired";

export function toLicenceState(status: OfflineProvisioningStatus | null | undefined): LicenceState {
  const licence = status?.license;
  if (!licence) {
    return NOT_READ_ONLY;
  }

  return {
    readOnly: Boolean(licence.readOnly),
    state: licence.state ?? null,
  };
}

export function licenceReadOnlyMessageKey(state: string | null): string {
  return state === "expired" ? LICENCE_EXPIRED_MESSAGE_KEY : LICENCE_READ_ONLY_MESSAGE_KEY;
}

export function* readLicenceStatus(): Generator<any, LicenceState, any> {
  if (!isOfflineFrontendMode()) {
    return NOT_READ_ONLY;
  }

  try {
    const status: OfflineProvisioningStatus = yield call(fetchOfflineProvisioningStatus);
    return toLicenceState(status);
  } catch {
    return NOT_READ_ONLY;
  }
}

function* publishLicenceStatus() {
  const licence: LicenceState = yield call(readLicenceStatus);
  yield put(setLicenceStatus(licence));
  return licence;
}

export default function* licenceSagas() {
  if (!isOfflineFrontendMode()) {
    return;
  }

  while (true) {
    yield call(publishLicenceStatus);
    yield delay(LICENCE_POLL_INTERVAL_MS);
  }
}
